import { render } from "./Pdf-Recibo.vue?vue&type=template&id=1443866a&scoped=true"
import script from "./Pdf-Recibo.vue?vue&type=script&lang=js"
export * from "./Pdf-Recibo.vue?vue&type=script&lang=js"

import "./Pdf-Recibo.vue?vue&type=style&index=0&id=1443866a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1443866a"]])

export default __exports__